import {combineReducers} from 'redux';
import UtilReducer from './util_reducer/UtilReducer';
import UserDataReducer from './user_data_reducer/UserDataReducer';

export default combineReducers({
  util: UtilReducer,
  userData: UserDataReducer
});
